import { Lotus } from "./Ornaments";
import { SanskritTerm } from "./SanskritTerm";
import { ScrollReveal } from "./ScrollReveal";
import { SectionHead } from "./SectionHead";

/**
 * The practice itself — one long statement, then a verse from the
 * Swarved set between hairlines like scripture on the page.
 */
export function Practice() {
  return (
    <section
      id="practice"
      className="relative scroll-mt-32 overflow-hidden bg-cream px-7 py-24 md:py-32"
    >
      <div className="mx-auto max-w-6xl">
        <SectionHead index="03" label="The Practice" />

        <ScrollReveal>
          <h2 className="font-display mt-14 max-w-4xl text-3xl leading-[1.3] text-warm-brown md:mt-20 md:text-[2.1rem]">
            A comfortable place to sit. The moments before sunrise, or before
            sunset. The simplest{" "}
            <SanskritTerm
              term="Abhyas"
              devanagari="अभ्यास"
              pronunciation="ub-yaas"
              meaning="Practice — the consistent, devoted practice of meditation."
              lore="Abhyas is not effort — it is devotion expressed through regularity. Ten minutes, morning and evening, is all that is asked."
            />
            . <span className="text-gold">Ten minutes. That is all.</span>{" "}
            {/* The breath — the same slow cadence as the loader and
                the hero cue, resting at the end of the sentence. */}
            <span
              className="breathe ml-3 inline-block h-2.5 w-2.5 rounded-full bg-gold-light align-middle"
              aria-hidden
            />
          </h2>
        </ScrollReveal>

        <ScrollReveal>
          <figure className="hairline-t hairline-b relative mt-20 max-w-2xl py-10 pl-9 md:mt-24">
            {/* The lotus rests on the rule, as a chapter ornament
                rests on the line above scripture. */}
            <span
              className="absolute -top-[10px] left-1/2 -translate-x-1/2 bg-cream px-5"
              aria-hidden
            >
              <Lotus size={30} className="text-gold opacity-90" />
            </span>
            <figcaption className="eyebrow">
              From the{" "}
              <SanskritTerm
                term="Swarved"
                devanagari="स्वर्वेद"
                pronunciation="swur-ved"
                meaning="The holy scripture authored by Sadguru Sadafal Deo Ji Maharaj — the complete encyclopaedia of the science of consciousness."
                lore="Composed from direct meditative experience in the state of Samadhi, the Swarved describes the entire spiritual journey in over 19,000 verses."
              />
            </figcaption>
            <blockquote className="verse-quote mt-5 max-w-xl font-serif text-2xl leading-[1.45] text-warm-brown italic md:text-[1.75rem]">
              Within you lies a light that no darkness can reach. Through
              practice, that light reveals itself — and everything becomes
              clear.
            </blockquote>
          </figure>
        </ScrollReveal>
      </div>
    </section>
  );
}
